// Hindi
export const hi = {
    weeklyRewards: 'साप्ताहिक पुरस्कार',
    days: 'दिन',
    hours: 'घंटे',
    minutes: 'मिनट',
    seconds: 'सेकंड',
    authenticating: 'प्रमाणीकरण हो रहा है',
    verifyWallet: 'कृपया प्रतीक्षा करें जब तक हम आपका वॉलेट सत्यापित करते हैं',
    authRequired: 'प्रमाणीकरण आवश्यक है',
    authFailed: 'प्रमाणीकरण विफल। कृपया पुनः प्रयास करें।',
    points: 'अंक',
    rank: 'रैंक',
    of: 'का',
    players: 'खिलाड़ी',
    weeklyTopPlayers: 'सप्ताह के शीर्ष खिलाड़ी',
    thisWeekLeaderboard: 'इस सप्ताह की लीडरबोर्ड',
    rankingsReset: 'रैंकिंग हर रविवार UTC मध्यरात्रि को रीसेट होती है',
    yourPoints: 'आपके अंक',
    dailyRewardAvailable: 'दैनिक पुरस्कार उपलब्ध!',
    nextClaimAvailable: 'अगला दावा उपलब्ध:',
    claimDailyReward: 'दैनिक पुरस्कार का दावा करें',
    claiming: 'दावा किया जा रहा है...',
    multiplier: 'गुणक',
    bonusPointsMultiplier: 'बोनस अंक गुणक',
    outOf: 'में से',
    loading: 'लोड हो रहा है...',
    errorLoading: 'लोड करने में त्रुटि',
    noEntries: 'अभी तक कोई प्रविष्टि नहीं',
    leaderboard: 'लीडरबोर्ड',
    tasks: 'कार्य',
    rules: 'नियम',
    profile: 'प्रोफ़ाइल',
    comingSoon: 'जल्द आ रहा है...',
    completedTasks: 'पूर्ण किए गए कार्य',
    dailyRewardsClaimed: 'दावा किए गए दैनिक पुरस्कार',
    times: 'बार',
    recentActivity: 'हाल की गतिविधि',
    noRewardsClaimed: 'अभी तक कोई पुरस्कार का दावा नहीं किया गया',
    dailyReward: 'दैनिक पुरस्कार',
    howItWorks: 'यह कैसे काम करता है',
    welcomeMessage:
        'Coinomi Rewards में आपका स्वागत है! विभिन्न कार्यों को पूरा करके अंक अर्जित करें और लीडरबोर्ड में ऊपर चढ़ें।',
    dailyRewardsTitle: 'दैनिक पुरस्कार',
    dailyRewardsRules: [
        'हर 24 घंटे में अपना दैनिक पुरस्कार प्राप्त करें',
        'प्रत्येक दावा आपको 100 अंक देता है',
        'अंक आपके गुणक के आधार पर गुणा किए जाते हैं',
    ],
    multiplierBonusesTitle: 'गुणक बोनस',
    multiplierBonusesRules: [
        '1x गुणक से शुरू करें',
        'टेलीग्राम को जोड़ने पर +10% बोनस',
        'ईमेल सत्यापन पर +10% बोनस',
        'अधिकतम पुरस्कारों के लिए बोनस जुड़ते हैं',
    ],
    leaderboardTitle: 'लीडरबोर्ड',
    leaderboardRules: [
        'अन्य खिलाड़ियों के साथ प्रतिस्पर्धा करें',
        'रैंकिंग रीयल-टाइम में अपडेट होती है',
        'शीर्ष खिलाड़ी विशेष पुरस्कार अर्जित करते हैं',
    ],
    boostEarningsTitle: 'अपनी कमाई बढ़ाएं',
    boostEarningsRules: [
        'बोनस अर्जित करने के लिए चुनौतियां पूरी करें',
        'हमारी टेलीग्राम कम्युनिटी में शामिल हों',
        'अधिकतम पुरस्कार के लिए सक्रिय रहें',
    ],
    challenges: 'चुनौतियां',
    telegramChallenge: 'टेलीग्राम चुनौती',
    emailChallenge: 'ईमेल चुनौती',
    connectTelegram: 'टेलीग्राम से जुड़ें',
    shareEmail: 'ईमेल साझा करें',
    telegramSuccess: '🎉 बधाई हो! अब आप सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त कर रहे हैं!',
    telegramPrompt:
        'सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त करने के लिए अपना टेलीग्राम अकाउंट लिंक करें!',
    emailSuccess: '🎉 बधाई हो! अब आप सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त कर रहे हैं!',
    emailPrompt: 'सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त करने के लिए अपना ईमेल साझा करें!',
    connectEmail: 'ईमेल कनेक्ट करें',
    cancel: 'रद्द करें',
    emailPrivacy: 'हम आपके ईमेल का उपयोग केवल महत्वपूर्ण अपडेट और पुरस्कार सूचनाओं के लिए करेंगे।',
    connectYourEmail: 'अपना ईमेल कनेक्ट करें',
    emailBonus: '🎉 अपना ईमेल कनेक्ट करके सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त करें!',
    enterValidEmail: 'कृपया एक वैध ईमेल पता दर्ज करें',
    emailAddress: 'ईमेल पता',
    errorSavingEmail: 'ईमेल सहेजने में त्रुटि। कृपया पुनः प्रयास करें।',
    claimButton: 'दावा करें',
    earnedReward: 'अर्जित पुरस्कार',
    rewardValue: '{{amount}} अंक',
    claimingReward: 'दावा किया जा रहा है...',
    claimSuccess: 'सफलतापूर्वक {{amount}} अंकों का दावा किया!',
    claimError: 'पुरस्कार का दावा करने में विफल। कृपया पुनः प्रयास करें।',
    privacyDisclaimer:
        'Coinomi व्यक्तिगत डेटा एकत्र नहीं करता है; एक तृतीय-पक्ष प्रणाली अंकों और सामाजिक लिंकिंग को सुरक्षित रूप से प्रबंधित करती है।',
    streakBonus: 'स्ट्रीक बोनस',
    streakDays: '{{days}}/5 दिन',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% अतिरिक्त',
    streakDescription: 'अधिकतम बोनस के लिए लगातार 5 दिन दावा करें',
    streakToday: 'आज',
    streakMissed: 'छूट गया',
    streakComplete: 'पूर्ण',
    streakActive: 'सक्रिय स्ट्रीक',
    streakLost: 'स्ट्रीक खो गई',
    streakNext: 'अगला',
    home: 'होम',
    currentStreak: 'वर्तमान स्ट्रीक',
    totalClaims: 'कुल दावे',
    userStats: 'आपके आंकड़े',
    referrals: 'रेफरल',
    referralProgram: 'रेफरल प्रोग्राम',
    howReferralWorks: 'रेफरल कैसे काम करते हैं:',
    referralSteps: [
        'अपना रेफरल लिंक दोस्तों के साथ साझा करें',
        'जब वे आपके लिंक का उपयोग करके जुड़ते हैं, तो वे आपके रेफरल बन जाते हैं',
        'प्रत्येक सक्रिय रेफरल के लिए बोनस अंक अर्जित करें',
        'अपने रेफरल और कमाई को यहां ट्रैक करें',
    ],
    referralRewards: 'रेफरल अंक प्रदान किए जाते हैं:',
    referralBonuses: [
        'किसी को संबद्ध करने पर 100 अंक',
        'रेफरल द्वारा प्राप्त किए गए प्रत्येक अंक का 10%',
    ],
    yourReferralLink: 'आपका रेफरल लिंक',
    copyToClipboard: 'क्लिपबोर्ड पर कॉपी करें',
    linkCopied: 'लिंक क्लिपबोर्ड पर कॉपी किया गया!',
    totalReferrals: 'कुल रेफरल',
    yourReferralCode: 'आपका रेफरल कोड',
    referralCodeCopied: 'रेफरल कोड कॉपी किया गया!',
    editReferralCode: 'रेफरल कोड संपादित करें',
    editReferralCodeInstructions:
        'नया रेफरल कोड चुनें। इसमें कम से कम 5 अक्षर होने चाहिए और इसमें अक्षर और संख्याएं हो सकती हैं।',
    newReferralCode: 'नया रेफरल कोड',
    referralCodeRequirements: 'न्यूनतम 5 अक्षर, केवल अक्षर और संख्याएं',
    updating: 'अपडेट हो रहा है...',
    update: 'अपडेट करें',
    referralCodeTaken: 'यह रेफरल कोड पहले से ही लिया जा चुका है',
    haveReferralCode: 'रेफरल कोड है?',
    enterReferralCodePrompt:
        'यदि किसी ने आपको रेफर किया है, तो अपने खातों को जोड़ने के लिए यहां उनका कोड दर्ज करें।',
    enterReferralCode: 'रेफरल कोड दर्ज करें',
    enterReferralCodeInstructions: 'आपके साथ साझा किया गया रेफरल कोड दर्ज करें।',
    referralCode: 'रेफरल कोड',
    referralCodeFormat: 'केवल अक्षर और संख्याएं',
    submitting: 'सबमिट किया जा रहा है...',
    submit: 'सबमिट करें',
    enterCode: 'कोड दर्ज करें',
    pleaseAddtoken: 'कृपया URL में एक टोकन पैरामीटर जोड़ें',
    authenticationError: 'प्रमाणीकरण के दौरान एक त्रुटि हुई',
    noUserFound: 'कोई उपयोगकर्ता नहीं मिला',
    userNotFoundMessage: 'उपयोगकर्ता डेटा नहीं मिल सका',
    backToHome: 'होम पर वापस जाएं',
    retry: 'पुनः प्रयास करें',
    baseMultiplier: 'बेस गुणक',
    telegramBonus: 'टेलीग्राम बोनस',
    referralChallenge: 'रेफरल चुनौती',
    referralChallengePrompt:
        'दोस्तों को आमंत्रित करें और बोनस अंक कमाएं! प्रत्येक रेफरल के लिए 100 अंक प्राप्त करें और उनकी कमाई का 10% भी।',
    startReferring: 'रेफर करना शुरू करें',
    referralSuccess:
        '🎉 बधाई हो! आपने सफलतापूर्वक उपयोगकर्ताओं को रेफर किया है और बोनस अंक कमा रहे हैं!',
    unranked: 'अनरैंक्ड',
    noPlayersYet: 'जुड़ने वाले पहले व्यक्ति बनें!',
    shareVia: 'के माध्यम से साझा करें',
    shareOn: '{{network}} पर साझा करें',
    shareInviteText:
        '🚀 मैं @CoinomiWallet के साथ मुफ्त क्रिप्टो कमा रहा हूं!\n\ncoinomi.com/downloads से Coinomi डाउनलोड करें और ऐप में #Coinomi Rewards में शामिल होने पर बोनस पाने के लिए मेरा रेफरल कोड {{referralCode}} दर्ज करें।',
    yourStatsThisWeek: 'इस सप्ताह के आपके आंकड़े',
    pointsMultiplier: 'अंक गुणक',
    yourRank: 'आपकी रैंक',
    rewards: 'पुरस्कार',
    daily: 'दैनिक',
    weekly: 'साप्ताहिक',
    claimRewards: 'पुरस्कार प्राप्त करें',
    player: 'खिलाड़ी',
    score: 'अंक',
    youHaveReferred_zero: 'आपने अभी तक किसी दोस्त को आमंत्रित नहीं किया है',
    youHaveReferred_one: 'आपने 1 दोस्त को आमंत्रित किया है',
    youHaveReferred_other: 'आपने {{count}} दोस्तों को आमंत्रित किया है',
    referYourFriends: 'अपने दोस्तों को आमंत्रित करें',
    dailyRewardTooltip: 'अपने अंक और पुरस्कार प्राप्त करने के लिए हर दिन वापस आएं',
    weeklyRewardTooltip: 'पुरस्कार एयरड्रॉप साप्ताहिक आधार पर वितरित किए जाते हैं',
    copy: 'कॉपी करें',
    // Twitter Challenge
    twitterChallenge: 'ट्विटर चुनौती',
    connectTwitter: 'ट्विटर से कनेक्ट करें',
    twitterSuccess: '🎉 बधाई हो! अब आप सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त कर रहे हैं!',
    twitterPrompt:
        'सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त करने के लिए अपना ट्विटर अकाउंट लिंक करें!',
    pleaseAddUserId: 'कृपया URL में userId पैरामीटर जोड़ें',
    emailChallengePrompt:
        'सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त करने के लिए अपना ईमेल साझा करें!',
    emailChallengeSuccess:
        '🎉 कनेक्ट हो गया! अब आप सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त कर रहे हैं!',
    followKoalaWalletChallenge: 'हमारा समर्थन करने के लिए ट्विटर पर @coinomiWallet को फॉलो करें!',
    twitterAuthSuccessTitle: 'ट्विटर सफलतापूर्वक कनेक्ट हो गया!',
    twitterAuthSuccessMessage:
        'आपने सफलतापूर्वक अपना ट्विटर अकाउंट कनेक्ट कर लिया है। अब आप ऐप का उपयोग जारी रख सकते हैं।',
    continueToApp: 'ऐप पर जाएं',
    twitter_like: 'ट्वीट को लाइक किया',
    twitter_retweet: 'ट्वीट को रीट्वीट किया',
    disconnect: 'डिस्कनेक्ट करें',
    followCoinomiWallet: 'Twitter पर @coinomiWallet को फॉलो करें और हमारा समर्थन करें!',
    connectedBonus: '🎉 कनेक्ट हो गया! अब आप सभी पुरस्कारों पर स्थायी 10% बोनस प्राप्त कर रहे हैं!',
};
